/**
 * 以图搜图
 *
 * Author:   gsm(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2024/7/3      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */

import React from 'react'
import PropTypes from "prop-types";
import {Spin, Popover} from 'antd';
import ImgCut from "./components/ImgCut";
import UploadImg from "../../../components/upload-img/index";
import "./index.less";

class ImgScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            imgList:[]
        }
    }

    selectImg(data) {
        let region = `${data.x},${Number(data.x)+Number(data.w)},${data.y},${Number(data.y)+Number(data.h)}`;
        let postData = {
            region:region
        }
        if(data.isCutImg){
            postData.cutImg = region;
        }
        this.props.onChangeImg(postData);
    }

    handleImg(imgList) {
        this.setState({
            imgList:imgList
        })
    }

    clickItem(data,index) {
        let imageFileUrl = this.props.imageFileUrl;
        let imageFileList = [].concat(this.props.imageFileList);
        let url = imageFileUrl.split(".");
        var defaultItem = {
            url:imageFileUrl,
            fileId:imageFileList[imageFileList.length-1].fileId,
            fileExtend:url[url.length-1]
        }
        let imgList = [].concat(this.state.imgList);
        imgList.splice(index,1);
        imgList.push(defaultItem);
        this.setState({
            imgList:imgList
        },()=>{
            this.props.onChangeImg({
                region:null,
                imageFileList:[data]
            })
        })

    }

    clearImg(){
        this.setState({
            imgList:[]
        })
    }

    render() {
        let {region, imageFileUrl, cutImg, cutImgData, detailRegion} = this.props;
        let {imgList = []} = this.state;
        return (
            <Spin spinning={this.props.loading}>
                <div className="image-top__wrap">
                    <div className="text-right">
                        <span className="tip-text">{__getServerLanguage('JieGuoBuZhun')}</span>
                        <Popover placement="bottomRight"
                                 title={false}
                                 trigger="click"
                                 content={<div>
                                     <div className="font_14 color089 margin-bottom-5">{__getServerLanguage('HuoQuZuiZhunQueZhao')}</div>
                                     <div className="font_12 color066">1.{__getServerLanguage('ShangChuanDeZhaoPian')}</div>
                                     <div className="font_12 color066">2.{__getServerLanguage('ShiYongChunSeBeiJing')}</div>
                                     <div className="font_12 color066">3.{__getServerLanguage('KeYiQieGeChanPinDe')}</div>
                                     <div className="font_12 color066">4.{__getServerLanguage('RuYouBaoZhuang')}</div>
                                 </div>}>
                            <i className="ri-error-warning-line color066 font_14"></i>
                        </Popover>
                    </div>
                    <div className="flex-box">
                        <div className="image-top__left-wrap">
                            <div className={`item org ${region ? '' : 'active'}`}>
                                <ImgCut src={imageFileUrl} data={region} callBack={this.selectImg.bind(this)}>
                                    <div>
                                        <span className="arrow">
                                            <i className="ri-check-line"></i>
                                        </span>
                                        <div>
                                            <div className="img" style={{
                                                backgroundImage: `url("${imageFileUrl}@!400")`,
                                            }} alt={__getServerLanguage('YiTuSouSuo')}/>
                                            <div className="content">
                                                <i className="iconfont icon-edit margin-right-5"></i>
                                                <span>{__getServerLanguage('KuangXuanZhuTi')}</span>
                                            </div>
                                        </div>
                                    </div>
                                </ImgCut>

                            </div>
                            {
                                detailRegion.map((item, index) => {
                                    let data = this.props.getImgData(item);
                                    return <div key={index} className={`item ${item.isSelect ? 'active' : ''}`} onClick={this.selectImg.bind(this, data)}>
                                      <span className="arrow">
                                          <i className="ri-check-line"></i>
                                      </span>
                                        <div className="img" style={{
                                            backgroundImage: `url("${imageFileUrl}?x-oss-process=image/crop,x_${data.x},y_${data.y},w_${data.w},h_${data.h}")`,
                                        }} alt={__getServerLanguage('TuPian')}/>
                                    </div>
                                })
                            }
                            {
                                (cutImg && region != cutImg) ?
                                    <div className={`item`} onClick={this.selectImg.bind(this, cutImgData)}>
                                        <div className="img" style={{
                                            backgroundImage: `url("${imageFileUrl}?x-oss-process=image/crop,x_${cutImgData.x},y_${cutImgData.y},w_${cutImgData.w},h_${cutImgData.h}")`,
                                        }} alt={__getServerLanguage('TuPian')}/>
                                    </div>
                                    :
                                    null
                            }
                        </div>
                        {
                            typeof window == 'object' ?
                                <div className="image-top__right-wrap">
                                    <div>
                                        {imgList.length > 0 ? <span className="small-title">{__getServerLanguage('DianJiKeQieHuanSouSuoTuPian')}</span> : null}
                                        <span className="small-title">{__getServerLanguage('ShangChuanTuPian')}（{imgList.length || 0}/6）</span>
                                        {imgList.length > 0 ? <span className="blue-title" onClick={this.clearImg.bind(this)}>{__getServerLanguage('QingKongBingChongXinShangChuan')}</span> : null}
                                    </div>
                                    <div>
                                        <UploadImg showNum={false}
                                                   keyName={'img-screen'}
                                                   multiple={true}
                                                   clickItem={this.clickItem.bind(this)}
                                                   defaultList={imgList}
                                                   num={6}
                                                   fileSizeLimit={4194304}
                                                   onChange={this.handleImg.bind(this)}></UploadImg>
                                    </div>
                                </div>
                                :
                                null
                        }
                    </div>
                </div>
            </Spin>
        )
    }
}

ImgScreen.defaultProps = {
    loading: false,
    onChangeImg:()=>{

    }
}

ImgScreen.propTypes = {}
export default ImgScreen;
